module.exports = __webpack_public_path__ + "91cc62ae2bf90ac0821205c81953239b.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/GC_BIERKIRCHE.jpg
// module id = 757
// module chunks = 0